import { useEmployeesState } from "atoms/employeesAtom";
import { useMemo, useState } from "react";
import { useSetAtom } from "jotai/index";

import { Row } from "components/Row/Row";
import { SearchInput } from "components/SearchInput/SearchInput";
import { VerticalSpace } from "components/VerticalSpace/VerticalSpace";
import { MediumText } from "components/MediumText/MediumText";
import { Divider } from "components/Divider/Divider";
import { Paragraph } from "components/Paragraph/Paragraph";

import { setAddEditEmployeeAtom } from "../../../atoms/modalAtom/modalAtom";

import { useGetEmployees } from "../api";
import styles from "../styles.module.scss";

export const EmployeesBody = (): JSX.Element => {
  const [searchText, setSearchText] = useState<string>("");
  const { employeesState, setEmployeesState } = useEmployeesState();
  const setAddEditEmployee = useSetAtom(setAddEditEmployeeAtom);

  const { data: employees = [] } = useGetEmployees({
    group_id: employeesState.activeGroupItem?.item.usersgroupid || null,
  });

  const handleRowClick = (employee: any) => {
    if (employeesState.activeItem?.usersid === employee.usersid) {
      setAddEditEmployee({ isEdit: true });
    } else {
      setEmployeesState((prev) => ({ ...prev, activeItem: employee }));
    }
  };

  const filteredEmployees = useMemo(() => {
    return employees.filter((employee: any) =>
      employee.name.toLowerCase().includes(searchText.toLowerCase())
    );
  }, [employees, searchText]);

  return (
    <div className={styles.container}>
      <VerticalSpace size={8} />
      <SearchInput callback={setSearchText} />
      <VerticalSpace size={16} />
      <Row>
        <MediumText>ФИО</MediumText>
        <MediumText>Код сотрудника</MediumText>
      </Row>
      <Divider />

      {filteredEmployees.map((employee: any) => (
        <Row
          key={employee.usersid}
          onClick={() => handleRowClick(employee)}
          isActive={employeesState.activeItem?.usersid === employee.usersid}
        >
          <Paragraph>{employee.name}</Paragraph>
          <Paragraph>{employee.code}</Paragraph>
        </Row>
      ))}
    </div>
  );
};
